import {
  Button,
  Card,
  Cascader,
  Drawer,
  Empty,
  Form,
  Modal,
  Pagination,
  Typography,
  message,
} from 'antd'
import Meta from 'antd/es/card/Meta'
import { memo, useCallback, useEffect, useRef, useState } from 'react'

import { deleteTextbook, getTextbookByCategoryId } from '~/services/textbook'
import { getTextBookTree } from '~/services/textbook-category'
import { ITextbookCategory } from '~/types/textbook-category'

import { ITextbook } from '../../types/textbook'
import ModalForm from './ModalForm'
import ModalUnit from './ModalUnit'
import { Container } from './style'

const Index = () => {
  const [loading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState<any[]>([])
  const [categoryList, setCategoryList] = useState<ITextbookCategory[]>([])
  const [categoryId, setCategoryId] = useState<number>(0)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [drawerFormData, setDrawerFormData] = useState<Partial<ITextbook>>({})
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false)
  // 保存章节后让单元弹窗重新读取转换状态：更换文件会自动排队重新转换。
  const [unitRefreshKey, setUnitRefreshKey] = useState(0)
  const [unitModalData, setUnitModalData] = useState<Partial<ITextbook>>({})

  const [page, setPage] = useState({
    page: 1,
    pageSize: 10,
  })

  const fetchData = useCallback(() => {
    setLoading(true)
    getTextbookByCategoryId(categoryId)
      .then((res) => {
        console.log(res)
        setDataSource(
          (res.data || []).map((item: any) => ({
            ...item,
            children: [],
          })),
        )
      })
      .catch((err) => {
        message.error(err?.message || '请求错误，请稍后再试')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [categoryId])

  useEffect(() => {
    getTextBookTree()
      .then((res) => {
        setCategoryList(res.data)
      })
      .catch(() => {
        //
      })
  }, [])

  const isFirst = useRef(true)
  if (isFirst.current) {
    isFirst.current = false
    fetchData()
  }

  const onSearch = useCallback(() => {
    setPage({
      page: 1,
      pageSize: 10,
    })
    fetchData()
  }, [fetchData])

  const addData = useCallback(() => {
    setDrawerFormData({
      level: 1,
      parentId: 0,
      author: '',
      tags: '',
      description: '',
      unit: '',
      chapter: '',
      previewUrl: '',
      onlineUrl: '',
      downloadUrl: '',
      order: 0,
    })
    setIsDrawerOpen(true)
  }, [])
  const closeDrawer = useCallback(() => {
    setDrawerFormData({})
    setIsDrawerOpen(false)
  }, [])

  return (
    <Container>
      <div className="top">
        <Form name="basic" autoComplete="off" layout="inline">
          <Form.Item label="教材分类" name="categoryId">
            <Cascader
              placeholder="请选择"
              style={{ width: 200, marginLeft: 8 }}
              options={categoryList}
              fieldNames={{ value: 'id', label: 'name' }}
              value={[categoryId!]}
              changeOnSelect
              onChange={(value) => {
                setPage({
                  page: 1,
                  pageSize: 10,
                })
                if (value) {
                  setCategoryId(value[value.length - 1])
                } else {
                  setCategoryId(0)
                }
              }}
            />
          </Form.Item>
          <Form.Item label="">
            <Button loading={loading} onClick={onSearch} type="primary">
              查询
            </Button>
          </Form.Item>
          <Form.Item>
            <Button onClick={addData}>新增</Button>
          </Form.Item>
        </Form>
      </div>
      <div className="table">
        {dataSource.length === 0 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 50,
              width: '100%',
            }}
          >
            <Empty description="选择教材分类查询" />
          </div>
        ) : (
          dataSource
            .slice((page.page - 1) * page.pageSize, page.page * page.pageSize)
            .map((item) => {
              return (
                <div key={item.id} className="card">
                  <Card
                    style={{ width: 350 }}
                    cover={
                      <div
                        style={{
                          padding: 1,
                          overflow: 'hidden',
                          boxSizing: 'border-box',
                        }}
                      >
                        <img
                          src={item.previewUrl}
                          style={{
                            height: 200,
                            objectFit: 'cover',
                            display: 'block',
                            width: '100%',
                          }}
                        />
                      </div>
                    }
                    actions={[
                      <Typography.Link
                        type="secondary"
                        key="view"
                        onClick={() => {
                          setUnitModalData(item)
                          setIsUnitModalOpen(true)
                        }}
                      >
                        查看单元
                      </Typography.Link>,
                      <Typography.Link
                        type="secondary"
                        key="view"
                        onClick={() => {
                          setDrawerFormData({
                            parentId: item.id,
                            level: 2,
                            categoryId: item.categoryId,
                            author: '',
                            tags: '',
                            description: '',
                            chapter: '',
                            previewUrl: '',
                            onlineUrl: '',
                            downloadUrl: '',
                            order: 0,
                          })
                          setIsDrawerOpen(true)
                        }}
                      >
                        添加单元
                      </Typography.Link>,
                      <Typography.Link
                        key="edit"
                        onClick={() => {
                          setDrawerFormData(item)
                          setIsDrawerOpen(true)
                        }}
                      >
                        编辑
                      </Typography.Link>,
                      <Typography.Link
                        type="danger"
                        key="delete"
                        onClick={() => {
                          Modal.confirm({
                            title: '确认删除？',
                            onOk: () => {
                              deleteTextbook(item.id)
                                .then(() => {
                                  message.success('成功')
                                  setPage({
                                    page: 1,
                                    pageSize: 10,
                                  })
                                  fetchData()
                                })
                                .catch((err) => {
                                  message.error(err.response?.data || '失败')
                                })
                            },
                            cancelText: '取消',
                            okText: '确认',
                            keyboard: true,
                            maskClosable: true,
                          })
                        }}
                      >
                        删除
                      </Typography.Link>,
                    ]}
                  >
                    <Meta title={item.title} />
                  </Card>
                </div>
              )
            })
        )}
      </div>
      <div className="pagination">
        <Pagination
          total={dataSource.length}
          current={page.page}
          pageSize={page.pageSize}
          showSizeChanger={false}
          onChange={(page, pageSize) => {
            setPage({
              page: page,
              pageSize,
            })
          }}
        />
      </div>
      <Drawer
        title={
          drawerFormData.id
            ? `编辑${drawerFormData.level === 1 ? '教材' : drawerFormData.level === 2 ? '单元' : '章节'}`
            : `新增${drawerFormData.level === 1 ? '教材' : drawerFormData.level === 2 ? '单元' : '章节'}`
        }
        open={isDrawerOpen}
        onClose={closeDrawer}
        width={450}
        destroyOnClose
      >
        <ModalForm
          data={drawerFormData}
          refreshTable={() => {
            fetchData()
            setUnitRefreshKey((key) => key + 1)
          }}
          categoryList={categoryList}
        />
      </Drawer>
      <Modal
        title={`教材： 【${unitModalData.title} 】单元列表`}
        open={isUnitModalOpen}
        onCancel={() => {
          setDrawerFormData({})
          setIsUnitModalOpen(false)
        }}
        destroyOnClose
        footer={null}
        width={800}
      >
        <ModalUnit
          textbook={unitModalData}
          refreshKey={unitRefreshKey}
          setDrawerFormData={setDrawerFormData}
          setIsDrawerOpen={setIsDrawerOpen}
        />
      </Modal>
    </Container>
  )
}

export default memo(Index)
